import { useMutation } from "@shared/lib/hooks";
import { BriefConfigService } from "../services/briefConfigService";
import { BRIEF_CONFIG_QUERY_KEY } from "@entities/brief/lib/constants";
import { IEditBriefConfigTaskRequest } from "@shared/lib/types/briefConfig";
import { ToastService } from "@shared/lib/services";

export function useEditBriefConfigTask(briefId: string) {
  const {
    mutate: editTask,
    isLoading: isEditing,
    isSuccess: isEdited,
  } = useMutation({
    mutationFn: ({ data }: { data: IEditBriefConfigTaskRequest }) =>
      BriefConfigService.editBriefConfigTask(data).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {},
    onSuccess: (c) => {
      c.invalidateQueries({ queryKey: BRIEF_CONFIG_QUERY_KEY(briefId) });
    },
  });

  return {
    editTask,
    isEditing,
    isEdited,
  };
}
